/* tslint:disable */
/* eslint-disable */
/**
 * Lightly API
 * Lightly.ai enables you to do self-supervised learning in an easy and intuitive way. The lightly.ai OpenAPI spec defines how one can interact with our REST API to unleash the full potential of lightly.ai
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: support@lightly.ai
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// SRC: https://github.com/OpenAPITools/openapi-generator/blob/master/modules/openapi-generator/src/main/resources/typescript-fetch/modelGeneric.mustache
// synched 02.02.2023
import * as yup from 'yup';
import typia from 'typia';
import * as fastJSON from 'fast-json-stringify';
import { Options, ArraySchema, ObjectSchema } from 'fast-json-stringify';
import { exists, mapValues } from '../runtime';
import type { DimensionalityReductionMethod } from './DimensionalityReductionMethod';
import { DimensionalityReductionMethodFromJSON, DimensionalityReductionMethodFromJSONTyped, DimensionalityReductionMethodToJSON, } from './DimensionalityReductionMethod';
import type { Embedding2dCoordinates } from './Embedding2dCoordinates';
import { Embedding2dCoordinatesFromJSON, Embedding2dCoordinatesFromJSONTyped, Embedding2dCoordinatesToJSON, } from './Embedding2dCoordinates';
/*
causes circular dependendies
*/
// SRC: https://github.com/OpenAPITools/openapi-generator/blob/master/modules/openapi-generator/src/main/resources/typescript-fetch/modelGenericInterfaces.mustache
// synced: 17.07.2023
/**
 *
 * @export
 * @interface Embedding2dData
 *
 */
// create custom validators for the regexes
typia.customValidators.insert("pattern_Embedding2dData_id")("string")(() => {
    const regex = new RegExp(/^[a-f0-9]{24}$/);
    return (value: string) => !!regex.exec(value);
});
typia.customValidators.insert("pattern_Embedding2dData_datasetId")("string")(() => {
    const regex = new RegExp(/^[a-f0-9]{24}$/);
    return (value: string) => !!regex.exec(value);
});
typia.customValidators.insert("pattern_Embedding2dData_embeddingId")("string")(() => {
    const regex = new RegExp(/^[a-f0-9]{24}$/);
    return (value: string) => !!regex.exec(value);
});
export interface Embedding2dData {
    /**
     * MongoDB ObjectId
     * #type string
     * #memberof Embedding2dData
        
        
    * @pattern_Embedding2dData_id
         */
    id: string;
    /**
     * MongoDB ObjectId
     * #type string
     * #memberof Embedding2dData
        
        
    * @pattern_Embedding2dData_datasetId
         */
    datasetId: string;
    /**
     * MongoDB ObjectId
     * #type string
     * #memberof Embedding2dData
        
        
    * @pattern_Embedding2dData_embeddingId
         */
    embeddingId: string;
    /**
     * Name of the 2d embedding (default is embedding name + __2d)
     * #type string
     * #memberof Embedding2dData
        
        
         */
    name: string;
    /**
     * unix timestamp in milliseconds
     * #type number
     * #memberof Embedding2dData
        
    * @minimum 0
            
         */
    createdAt: number;
    /**
     *
     * #type DimensionalityReductionMethod
     * #memberof Embedding2dData
        
        
         */
    dimensionalityReductionMethod: DimensionalityReductionMethod;
    /**
     *
     * #type Embedding2dCoordinates
     * #memberof Embedding2dData
        
        
         */
    coordinatesDimension1?: Embedding2dCoordinates;
    /**
     *
     * #type Embedding2dCoordinates
     * #memberof Embedding2dData
        
        
         */
    coordinatesDimension2?: Embedding2dCoordinates;
}
/**
 * Check if a given object implements the Embedding2dData interface.
 */
export function instanceOfEmbedding2dData(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "datasetId" in value;
    isInstance = isInstance && "embeddingId" in value;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "createdAt" in value;
    isInstance = isInstance && "dimensionalityReductionMethod" in value;
    return isInstance;
}
/* LIGHTLY CUSTOM START -> modelGeneric */
import { DimensionalityReductionMethodValidator, DimensionalityReductionMethodStringifyShape, DimensionalityReductionMethodStringifyShapeProperties, } from './DimensionalityReductionMethod';
import { Embedding2dCoordinatesValidator, Embedding2dCoordinatesStringifyShape, Embedding2dCoordinatesStringifyShapeProperties, } from './Embedding2dCoordinates';
export const Embedding2dDataTypiaAssertEquals = (input: any) => {
    return ((input: any): Embedding2dData => {
        const __is = (input: any, _exceptionable: boolean = true): input is Embedding2dData => {
            const $is_custom = (typia.createAssertEquals as any).is_custom;
            const $join = (typia.createAssertEquals as any).join;
            const $io0 = (input: any, _exceptionable: boolean = true): boolean => "string" === typeof input.id && $is_custom("pattern_Embedding2dData_id", "string", "", input.id) && ("string" === typeof input.datasetId && $is_custom("pattern_Embedding2dData_datasetId", "string", "", input.datasetId)) && ("string" === typeof input.embeddingId && $is_custom("pattern_Embedding2dData_embeddingId", "string", "", input.embeddingId)) && "string" === typeof input.name && ("number" === typeof input.createdAt && 0 <= input.createdAt) && ("PCA" === input.dimensionalityReductionMethod || "TSNE" === input.dimensionalityReductionMethod || "UMAP" === input.dimensionalityReductionMethod) && (undefined === input.coordinatesDimension1 || "object" === typeof input.coordinatesDimension1 && null !== input.coordinatesDimension1 && $io1(input.coordinatesDimension1, true && _exceptionable)) && (undefined === input.coordinatesDimension2 || "object" === typeof input.coordinatesDimension2 && null !== input.coordinatesDimension2 && $io1(input.coordinatesDimension2, true && _exceptionable)) && (6 === Object.keys(input).length || Object.keys(input).every((key: any) => {
                if (["id", "datasetId", "embeddingId", "name", "createdAt", "dimensionalityReductionMethod", "coordinatesDimension1", "coordinatesDimension2"].some((prop: any) => key === prop))
                    return true;
                const value = input[key];
                if (undefined === value)
                    return true;
                return false;
            }));
            const $io1 = (input: any, _exceptionable: boolean = true): boolean => "number" === typeof input.length && Object.keys(input).every((key: any) => {
                if (["length"].some((prop: any) => key === prop))
                    return true;
                const value = input[key];
                if (undefined === value)
                    return true;
                if (RegExp(/^[+-]?\d+(?:\.\d+)?(?:[eE][+-]?\d+)?$/).test(key))
                    return "number" === typeof value;
                return false;
            });
            return "object" === typeof input && null !== input && $io0(input, true);
        };
        if (false === __is(input))
            ((input: any, _path: string, _exceptionable: boolean = true): input is Embedding2dData => {
                const $guard = (typia.createAssertEquals as any).guard;
                const $is_custom = (typia.createAssertEquals as any).is_custom;
                const $join = (typia.createAssertEquals as any).join;
                const $ao0 = (input: any, _path: string, _exceptionable: boolean = true): boolean => ("string" === typeof input.id && ($is_custom("pattern_Embedding2dData_id", "string", "", input.id) || $guard(_exceptionable, {
                    path: _path + ".id",
                    expected: "string (@pattern_Embedding2dData_id)",
                    value: input.id
                })) || $guard(_exceptionable, {
                    path: _path + ".id",
                    expected: "string",
                    value: input.id
                })) && ("string" === typeof input.datasetId && ($is_custom("pattern_Embedding2dData_datasetId", "string", "", input.datasetId) || $guard(_exceptionable, {
                    path: _path + ".datasetId",
                    expected: "string (@pattern_Embedding2dData_datasetId)",
                    value: input.datasetId
                })) || $guard(_exceptionable, {
                    path: _path + ".datasetId",
                    expected: "string",
                    value: input.datasetId
                })) && ("string" === typeof input.embeddingId && ($is_custom("pattern_Embedding2dData_embeddingId", "string", "", input.embeddingId) || $guard(_exceptionable, {
                    path: _path + ".embeddingId",
                    expected: "string (@pattern_Embedding2dData_embeddingId)",
                    value: input.embeddingId
                })) || $guard(_exceptionable, {
                    path: _path + ".embeddingId",
                    expected: "string",
                    value: input.embeddingId
                })) && ("string" === typeof input.name || $guard(_exceptionable, {
                    path: _path + ".name",
                    expected: "string",
                    value: input.name
                })) && ("number" === typeof input.createdAt && (0 <= input.createdAt || $guard(_exceptionable, {
                    path: _path + ".createdAt",
                    expected: "number (@minimum 0)",
                    value: input.createdAt
                })) || $guard(_exceptionable, {
                    path: _path + ".createdAt",
                    expected: "number",
                    value: input.createdAt
                })) && ("PCA" === input.dimensionalityReductionMethod || "TSNE" === input.dimensionalityReductionMethod || "UMAP" === input.dimensionalityReductionMethod || $guard(_exceptionable, {
                    path: _path + ".dimensionalityReductionMethod",
                    expected: "(\"PCA\" | \"TSNE\" | \"UMAP\")",
                    value: input.dimensionalityReductionMethod
                })) && (undefined === input.coordinatesDimension1 || ("object" === typeof input.coordinatesDimension1 && null !== input.coordinatesDimension1 || $guard(_exceptionable, {
                    path: _path + ".coordinatesDimension1",
                    expected: "(Embedding2dCoordinates | undefined)",
                    value: input.coordinatesDimension1
                })) && $ao1(input.coordinatesDimension1, _path + ".coordinatesDimension1", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".coordinatesDimension1",
                    expected: "(Embedding2dCoordinates | undefined)",
                    value: input.coordinatesDimension1
                })) && (undefined === input.coordinatesDimension2 || ("object" === typeof input.coordinatesDimension2 && null !== input.coordinatesDimension2 || $guard(_exceptionable, {
                    path: _path + ".coordinatesDimension2",
                    expected: "(Embedding2dCoordinates | undefined)",
                    value: input.coordinatesDimension2
                })) && $ao1(input.coordinatesDimension2, _path + ".coordinatesDimension2", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".coordinatesDimension2",
                    expected: "(Embedding2dCoordinates | undefined)",
                    value: input.coordinatesDimension2
                })) && (6 === Object.keys(input).length || (false === _exceptionable || Object.keys(input).every((key: any) => {
                    if (["id", "datasetId", "embeddingId", "name", "createdAt", "dimensionalityReductionMethod", "coordinatesDimension1", "coordinatesDimension2"].some((prop: any) => key === prop))
                        return true;
                    const value = input[key];
                    if (undefined === value)
                        return true;
                    return $guard(_exceptionable, {
                        path: _path + $join(key),
                        expected: "undefined",
                        value: value
                    });
                })));
                const $ao1 = (input: any, _path: string, _exceptionable: boolean = true): boolean => ("number" === typeof input.length || $guard(_exceptionable, {
                    path: _path + ".length",
                    expected: "number",
                    value: input.length
                })) && (false === _exceptionable || Object.keys(input).every((key: any) => {
                    if (["length"].some((prop: any) => key === prop))
                        return true;
                    const value = input[key];
                    if (undefined === value)
                        return true;
                    if (RegExp(/^[+-]?\d+(?:\.\d+)?(?:[eE][+-]?\d+)?$/).test(key))
                        return "number" === typeof value || $guard(_exceptionable, {
                            path: _path + $join(key),
                            expected: "number",
                            value: value
                        });
                    return $guard(_exceptionable, {
                        path: _path + $join(key),
                        expected: "undefined",
                        value: value
                    });
                }));
                return ("object" === typeof input && null !== input || $guard(true, {
                    path: _path + "",
                    expected: "Embedding2dData",
                    value: input
                })) && $ao0(input, _path + "", true) || $guard(true, {
                    path: _path + "",
                    expected: "Embedding2dData",
                    value: input
                });
            })(input, "$input", true);
        return input;
    })(input);
};
export const Embedding2dDataTypiaAssertStringify = (input: Embedding2dData): string => {
    return ((input: any): string => { const assert = (input: any): Embedding2dData => {
        const __is = (input: any): input is Embedding2dData => {
            const $is_custom = (typia.createAssertStringify as any).is_custom;
            const $join = (typia.createAssertStringify as any).join;
            const $io0 = (input: any): boolean => "string" === typeof input.id && $is_custom("pattern_Embedding2dData_id", "string", "", input.id) && ("string" === typeof input.datasetId && $is_custom("pattern_Embedding2dData_datasetId", "string", "", input.datasetId)) && ("string" === typeof input.embeddingId && $is_custom("pattern_Embedding2dData_embeddingId", "string", "", input.embeddingId)) && "string" === typeof input.name && ("number" === typeof input.createdAt && !Number.isNaN(input.createdAt) && 0 <= input.createdAt) && ("PCA" === input.dimensionalityReductionMethod || "TSNE" === input.dimensionalityReductionMethod || "UMAP" === input.dimensionalityReductionMethod) && (undefined === input.coordinatesDimension1 || "object" === typeof input.coordinatesDimension1 && null !== input.coordinatesDimension1 && $io1(input.coordinatesDimension1)) && (undefined === input.coordinatesDimension2 || "object" === typeof input.coordinatesDimension2 && null !== input.coordinatesDimension2 && $io1(input.coordinatesDimension2));
            const $io1 = (input: any): boolean => "number" === typeof input.length && !Number.isNaN(input.length) && Object.keys(input).every((key: any) => {
                if (["length"].some((prop: any) => key === prop))
                    return true;
                const value = input[key];
                if (undefined === value)
                    return true;
                if (RegExp(/^[+-]?\d+(?:\.\d+)?(?:[eE][+-]?\d+)?$/).test(key))
                    return "number" === typeof value && !Number.isNaN(value);
                return true;
            });
            return "object" === typeof input && null !== input && $io0(input);
        };
        if (false === __is(input))
            ((input: any, _path: string, _exceptionable: boolean = true): input is Embedding2dData => {
                const $guard = (typia.createAssertStringify as any).guard;
                const $is_custom = (typia.createAssertStringify as any).is_custom;
                const $join = (typia.createAssertStringify as any).join;
                const $ao0 = (input: any, _path: string, _exceptionable: boolean = true): boolean => ("string" === typeof input.id && ($is_custom("pattern_Embedding2dData_id", "string", "", input.id) || $guard(_exceptionable, {
                    path: _path + ".id",
                    expected: "string (@pattern_Embedding2dData_id)",
                    value: input.id
                })) || $guard(_exceptionable, {
                    path: _path + ".id",
                    expected: "string",
                    value: input.id
                })) && ("string" === typeof input.datasetId && ($is_custom("pattern_Embedding2dData_datasetId", "string", "", input.datasetId) || $guard(_exceptionable, {
                    path: _path + ".datasetId",
                    expected: "string (@pattern_Embedding2dData_datasetId)",
                    value: input.datasetId
                })) || $guard(_exceptionable, {
                    path: _path + ".datasetId",
                    expected: "string",
                    value: input.datasetId
                })) && ("string" === typeof input.embeddingId && ($is_custom("pattern_Embedding2dData_embeddingId", "string", "", input.embeddingId) || $guard(_exceptionable, {
                    path: _path + ".embeddingId",
                    expected: "string (@pattern_Embedding2dData_embeddingId)",
                    value: input.embeddingId
                })) || $guard(_exceptionable, {
                    path: _path + ".embeddingId",
                    expected: "string",
                    value: input.embeddingId
                })) && ("string" === typeof input.name || $guard(_exceptionable, {
                    path: _path + ".name",
                    expected: "string",
                    value: input.name
                })) && ("number" === typeof input.createdAt && !Number.isNaN(input.createdAt) && (0 <= input.createdAt || $guard(_exceptionable, {
                    path: _path + ".createdAt",
                    expected: "number (@minimum 0)",
                    value: input.createdAt
                })) || $guard(_exceptionable, {
                    path: _path + ".createdAt",
                    expected: "number",
                    value: input.createdAt
                })) && ("PCA" === input.dimensionalityReductionMethod || "TSNE" === input.dimensionalityReductionMethod || "UMAP" === input.dimensionalityReductionMethod || $guard(_exceptionable, {
                    path: _path + ".dimensionalityReductionMethod",
                    expected: "(\"PCA\" | \"TSNE\" | \"UMAP\")",
                    value: input.dimensionalityReductionMethod
                })) && (undefined === input.coordinatesDimension1 || ("object" === typeof input.coordinatesDimension1 && null !== input.coordinatesDimension1 || $guard(_exceptionable, {
                    path: _path + ".coordinatesDimension1",
                    expected: "(Embedding2dCoordinates | undefined)",
                    value: input.coordinatesDimension1
                })) && $ao1(input.coordinatesDimension1, _path + ".coordinatesDimension1", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".coordinatesDimension1",
                    expected: "(Embedding2dCoordinates | undefined)",
                    value: input.coordinatesDimension1
                })) && (undefined === input.coordinatesDimension2 || ("object" === typeof input.coordinatesDimension2 && null !== input.coordinatesDimension2 || $guard(_exceptionable, {
                    path: _path + ".coordinatesDimension2",
                    expected: "(Embedding2dCoordinates | undefined)",
                    value: input.coordinatesDimension2
                })) && $ao1(input.coordinatesDimension2, _path + ".coordinatesDimension2", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".coordinatesDimension2",
                    expected: "(Embedding2dCoordinates | undefined)",
                    value: input.coordinatesDimension2
                }));
                const $ao1 = (input: any, _path: string, _exceptionable: boolean = true): boolean => ("number" === typeof input.length && !Number.isNaN(input.length) || $guard(_exceptionable, {
                    path: _path + ".length",
                    expected: "number",
                    value: input.length
                })) && (false === _exceptionable || Object.keys(input).every((key: any) => {
                    if (["length"].some((prop: any) => key === prop))
                        return true;
                    const value = input[key];
                    if (undefined === value)
                        return true;
                    if (RegExp(/^[+-]?\d+(?:\.\d+)?(?:[eE][+-]?\d+)?$/).test(key))
                        return "number" === typeof value && !Number.isNaN(value) || $guard(_exceptionable, {
                            path: _path + $join(key),
                            expected: "number",
                            value: value
                        });
                    return true;
                }));
                return ("object" === typeof input && null !== input || $guard(true, {
                    path: _path + "",
                    expected: "Embedding2dData",
                    value: input
                })) && $ao0(input, _path + "", true) || $guard(true, {
                    path: _path + "",
                    expected: "Embedding2dData",
                    value: input
                });
            })(input, "$input", true);
        return input;
    }; const stringify = (input: Embedding2dData): string => {
        const $io1 = (input: any): boolean => "number" === typeof input.length && Object.keys(input).every((key: any) => {
            if (["length"].some((prop: any) => key === prop))
                return true;
            const value = input[key];
            if (undefined === value)
                return true;
            if (RegExp(/^[+-]?\d+(?:\.\d+)?(?:[eE][+-]?\d+)?$/).test(key))
                return "number" === typeof value;
            return true;
        });
        const $string = (typia.createAssertStringify as any).string;
        const $throws = (typia.createAssertStringify as any).throws;
        const $join = (typia.createAssertStringify as any).join;
        const $tail = (typia.createAssertStringify as any).tail;
        const $is_custom = (typia.createAssertStringify as any).is_custom;
        const $so0 = (input: any): any => `{${undefined === input.coordinatesDimension1 ? "" : `"coordinatesDimension1":${undefined !== input.coordinatesDimension1 ? $so1(input.coordinatesDimension1) : undefined},`}${undefined === input.coordinatesDimension2 ? "" : `"coordinatesDimension2":${undefined !== input.coordinatesDimension2 ? $so1(input.coordinatesDimension2) : undefined},`}"id":${$string(input.id)},"datasetId":${$string(input.datasetId)},"embeddingId":${$string(input.embeddingId)},"name":${$string(input.name)},"createdAt":${input.createdAt},"dimensionalityReductionMethod":${(() => {
            if ("string" === typeof input.dimensionalityReductionMethod)
                return $string(input.dimensionalityReductionMethod);
            if ("string" === typeof input.dimensionalityReductionMethod)
                return "\"" + input.dimensionalityReductionMethod + "\"";
            $throws({
                expected: "(\"PCA\" | \"TSNE\" | \"UMAP\")",
                value: input.dimensionalityReductionMethod
            });
        })()}}`;
        const $so1 = (input: any): any => `{${$tail(`"length":${input.length},${Object.entries(input).map(([key, value]: [string, any]) => { if (undefined === value)
            return ""; if (["length"].some((regular: any) => regular === key))
            return ""; if (RegExp(/^[+-]?\d+(?:\.\d+)?(?:[eE][+-]?\d+)?$/).test(key))
            return `${JSON.stringify(key)}:${value}`; return ""; }).filter((str: any) => "" !== str).join(",")}`)}}`;
        return $so0(input);
    }; return stringify(assert(input)); })(input);
};
export const Embedding2dDataValidatorShape = {
    'id': yup.string().matches(/^[a-f0-9]{24}$/).defined(),
    'datasetId': yup.string().matches(/^[a-f0-9]{24}$/).defined(),
    'embeddingId': yup.string().matches(/^[a-f0-9]{24}$/).defined(),
    'name': yup.string().defined(),
    'createdAt': yup.number().min(0).defined(),
    'dimensionalityReductionMethod': DimensionalityReductionMethodValidator.defined(),
    'coordinatesDimension1': Embedding2dCoordinatesValidator.optional().default(undefined),
    'coordinatesDimension2': Embedding2dCoordinatesValidator.optional().default(undefined),
};
export const Embedding2dDataValidator = yup.object().shape(Embedding2dDataValidatorShape);
export const Embedding2dDataStringifyShapeProperties: ObjectSchema['properties'] = {
    'id': {
        'type': 'string',
        'pattern': "/^[a-f0-9]{24}$/".slice(1, -1),
    } as unknown as fastJSON.StringSchema,
    'datasetId': {
        'type': 'string',
        'pattern': "/^[a-f0-9]{24}$/".slice(1, -1),
    } as unknown as fastJSON.StringSchema,
    'embeddingId': {
        'type': 'string',
        'pattern': "/^[a-f0-9]{24}$/".slice(1, -1),
    } as unknown as fastJSON.StringSchema,
    'name': {
        'type': 'string',
    } as unknown as fastJSON.StringSchema,
    'createdAt': {
        'type': 'number',
        'minimum': 0,
    } as unknown as fastJSON.NumberSchema,
    'dimensionalityReductionMethod': DimensionalityReductionMethodStringifyShape,
    'coordinatesDimension1': Embedding2dCoordinatesStringifyShape,
    'coordinatesDimension2': Embedding2dCoordinatesStringifyShape,
};
export const Embedding2dDataStringifyShape: ObjectSchema = {
    title: 'Embedding2dData Stringifier',
    type: 'object',
    properties: {
        ...Embedding2dDataStringifyShapeProperties
    },
    required: [
        'id',
        'datasetId',
        'embeddingId',
        'name',
        'createdAt',
        'dimensionalityReductionMethod',
    ],
};
export const Embedding2dDataStringifyCompiled = (typeof process === 'object' && String(process) === '[object process]') ?
    fastJSON.build(Embedding2dDataStringifyShape, {
        ajv: {
            // since we are already doing this with yup, lets skip
            validateSchema: false,
            ownProperties: true,
            validateFormats: false,
        },
        largeArrayMechanism: 'json-stringify',
        largeArraySize: 1000,
    } as Options)
    :
        () => { throw new Error('fast-json-stringify only works in nodejs'); };
export const Embedding2dDataStringify: (data: Embedding2dData) => string = Embedding2dDataStringifyCompiled;
/* LIGHTLY CUSTOM END -> Generic */
export function Embedding2dDataFromJSON(json: any): Embedding2dData {
    return Embedding2dDataFromJSONTyped(json, false);
}
export function Embedding2dDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): Embedding2dData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    /* causes circular depdendencies
*/
    return {
        'id': json['id'],
        'datasetId': json['datasetId'],
        'embeddingId': json['embeddingId'],
        'name': json['name'],
        'createdAt': json['createdAt'],
        'dimensionalityReductionMethod': DimensionalityReductionMethodFromJSON(json['dimensionalityReductionMethod']),
        'coordinatesDimension1': !exists(json, 'coordinatesDimension1') ? undefined : Embedding2dCoordinatesFromJSON(json['coordinatesDimension1']),
        'coordinatesDimension2': !exists(json, 'coordinatesDimension2') ? undefined : Embedding2dCoordinatesFromJSON(json['coordinatesDimension2']),
    };
}
export function Embedding2dDataToJSON(value?: Embedding2dData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'datasetId': value.datasetId,
        'embeddingId': value.embeddingId,
        'name': value.name,
        'createdAt': value.createdAt,
        'dimensionalityReductionMethod': DimensionalityReductionMethodToJSON(value.dimensionalityReductionMethod),
        'coordinatesDimension1': Embedding2dCoordinatesToJSON(value.coordinatesDimension1),
        'coordinatesDimension2': Embedding2dCoordinatesToJSON(value.coordinatesDimension2),
    };
}
